export const GET_FLIGHT_INFO_START = '@briefing/GET_FLIGHT_INFO_START'
export const GET_FLIGHT_INFO_SUCCESS = '@briefing/GET_FLIGHT_INFO_SUCCESS'
export const GET_FLIGHT_INFO_FAILURE = '@briefing/GET_FLIGHT_INFO_FAILURE'


// WEBPACK FOOTER //
// ./src/screens/briefing/actions/types.js